// Registers every integration into `integrationRegistry`. Must stay first:
// modules below snapshot the registry at module scope.
import "@p0security/integrations-registry";

import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import React from "react";
import ReactDOM from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "theme/ThemeProvider";

import { App } from "./components/App/App";
import { CustomOidcProvider } from "./components/Login/providers/CustomOidcProvider";
import { ErrorFallback } from "./components/common/ErrorFallback";

import "./index.less";

import PostHogProviderWrapper from "./postHogProviderWrapper";
import reportWebVitals from "./reportWebVitals";
import { SentryMonitor } from "./sentry";

import "./tailwind.css";

// TODO ENG-2130 do not leak configuration - load LD entirely from backend
const LD_CLIENT_SIDE_IDS_BY_HOSTNAME: Record<string, string> = {
  "p0.app": "644178eaf2d05912f9c32810",
  "cna.p0.app": "664249465ed4bd0f93c426d5", // prod-cna-central environment
  "splunk-nonprod.p0.app": "67055ebeb60325083684bee2", // prod-splunk-nonprod environment
  "splunk.p0.app": "670eb9a11abc32082c48f4c9", // prod-splunk-live environment
  "demo.p0.app": "683f55fc9723130dc1a539d0", // prod-demo environment
  "stage.p0.app": "6a836db921be370b72cd59ad",
};
const DEFAULT_LD_CLIENT_SIDE_ID = "644178eaf2d05912f9c3280f";

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID:
      LD_CLIENT_SIDE_IDS_BY_HOSTNAME[window?.location.hostname] ??
      DEFAULT_LD_CLIENT_SIDE_ID,
    options: {
      streaming: true,
    },
  });
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <SentryMonitor>
          <LDProvider>
            <PostHogProviderWrapper>
              <CustomOidcProvider>
                <ThemeProvider>
                  <ErrorBoundary FallbackComponent={ErrorFallback}>
                    <App />
                  </ErrorBoundary>
                </ThemeProvider>
              </CustomOidcProvider>
            </PostHogProviderWrapper>
          </LDProvider>
        </SentryMonitor>
      </BrowserRouter>
    </React.StrictMode>
  );
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
